import { inject, Injectable, signal } from '@angular/core';
import { catchError, filter, finalize, map, Observable, of, shareReplay, tap } from 'rxjs';

import { Province } from '@app/core/types/province.interface';

import { AppSettingApiService } from './app-setting-api.service';


@Injectable({
  providedIn: 'root',
})
export class AppProvinceService {
  private readonly api = inject(AppSettingApiService);

  readonly provinces = signal<Province[] | null>(null);
  readonly loading = signal(false);

  private sessionLoaded = false;
  private inflight$: Observable<boolean> | null = null;

  ensureLoaded(force = false): Observable<boolean> {
    if (!force && this.sessionLoaded && this.provinces()) {
      return of(true);
    }

    if (this.inflight$) {
      return this.inflight$;
    }

    this.loading.set(true);

    this.inflight$ = this.api.getProvinces().pipe(
      filter(response => response.success),
      map(response => response.result),
      tap(result => this.setData(result)),
      map(() => true),
      catchError(() => of(false)),
      finalize(() => {
        this.loading.set(false);
        this.inflight$ = null;
      }),
      shareReplay(1),
    );

    return this.inflight$;
  }

  refresh(): Observable<boolean> {
    return this.ensureLoaded(true);
  }

  setData(provinces: Province[]): void {
    this.provinces.set(provinces);
    this.sessionLoaded = true;
  }

  clear(): void {
    this.provinces.set(null);
    this.sessionLoaded = false;
    this.inflight$ = null;
  }
}
